<template>
  <div>
    <be-ready-list-filter
      v-model="filter"
      @hospitals="hospitals = $event"
      @fetch="fetch"
    ></be-ready-list-filter>
    <be-ready-table
      :isLoading="isLoading"
      :list="list"
      @fetch="fetch"
    ></be-ready-table>
  </div>
</template>

<script>
import recipientService from "../../assets/services/recipient.service";
import BeReadyTable from "../../components/waitingList/bereadyWaitList/BeReadyTable.vue";
import BeReadyListFilter from "../../components/waitingList/bereadyWaitList/BeReadyListFilter.vue";
export default {
  components: { BeReadyListFilter, BeReadyTable },
  data() {
    return {
      isLoading: false,
      filter: {},
      list: [],
      hospitals: [],
    };
  },
  methods: {
    async fetch() {
      const vm = this;
      try {
        vm.isLoading = true;
        vm.list = [];
        let { data } = await recipientService.getBeReadyList(vm.filter);
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (!status) {
          vm.$alert.show(msg);
          return;
        }
        vm.list = list;
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
